import React from "react";
import { Typography } from "antd";
import { shortenAddress } from "../../utils/utils";

export const EthExplorerLink = (props: {
    address: string;
    cluster: string | undefined;
    type: string;
    code?: boolean;
    style?: React.CSSProperties;
    length?: number;
}) => {
    const { type, code } = props;

    const length = props.length ?? 9;

    const clusterParam =
        props.cluster !== undefined ? "?cluster=" + props.cluster : "";

    return (
        <a
            href={`https://explorer-mumbai.maticvigil.com/tx/${props.address}/internal-transactions`}
            // eslint-disable-next-line react/jsx-no-target-blank
            target="_blank"
            rel="noreferrer"
            title={props.address}
            className="ExplorerLink"
            style={props.style}
        >
            {code ? (
                <Typography.Text style={props.style} code>
                    {shortenAddress(props.address, length)}
                </Typography.Text>
            ) : (
                shortenAddress(props.address, length)
            )}
        </a>
    );
};
